// Customizable Area Start
import React, { Component } from "react";
import { Box, styled, Typography } from "@mui/material";
const InAudioIcon = require("./assets/Incoming_Audio.svg").default;
const InVideoIcon = require("./assets/Incoming_Video.svg").default;
const OutAudioIcon = require("./assets/Outgoing_Audio.svg").default;
const OutVideoIcon = require("./assets/Outgoing_Video.svg").default;

export type CallTypes = "in_audio" | "in_video" | "out_audio" | "out_video";

const CALL_ICONS = {
  in_audio: InAudioIcon,
  in_video: InVideoIcon,
  out_audio: OutAudioIcon,
  out_video: OutVideoIcon,
};

const MainWrapper = styled(Box)({
  display: "flex",
  marginBottom: "15px",
  "&:has(.own_message)": {
    justifyContent: "flex-end",
  },
});

const CallBubble = styled(Box)({
  borderRadius: "0px 12px 12px 12px ",
  padding: "15px 10px 8px",
  position: "relative",
  backgroundColor: "#F1F5F9",
  display: "flex",
  gap: "8px",
  "&::before": {
    content: "''",
    position: "absolute",
    left: "-10px",
    top: "0",
    width: "0",
    height: "0",
    border: "10px solid transparent",
    borderRightColor: "#F1F5F9",
    borderTopColor: "#F1F5F9",
  },
  "&.own_message": {
    borderRadius: "12px 0px 12px 12px",
    backgroundColor: "#EFF6FF",
    "&::before": {
      left: "unset",
      right: "-10px",
      borderLeftColor: "#F1F5F9",
      borderRightColor: "transparent",
    },
  },
});

const CallContentWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  paddingBottom: "7px",
});

const CallIconWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isMissedCall",
})<{ isMissedCall?: boolean }>(({ isMissedCall }) => ({
  height: "40px",
  width: "40px",
  borderRadius: "50%",
  backgroundColor: "#fff",
  padding: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& img": {
    height: "24px",
    width: "24px",
    filter: isMissedCall
      ? "brightness(0) saturate(100%) invert(23%) sepia(91%) saturate(5836%) hue-rotate(355deg) brightness(96%) contrast(79%)"
      : "brightness(0) saturate(100%) invert(67%) sepia(19%) saturate(298%) hue-rotate(175deg) brightness(92%) contrast(96%)",
  },
}));

const TitleText = styled(Typography)({
  fontWeight: 400,
  fontSize: "0.875rem",
  color: "#0F172A",
  flex: 1,
  "@media (max-width: 414px)": {
    fontSize: "0.80rem",
  },
});

const SubTitleText = styled(Typography)({
  fontWeight: 400,
  fontSize: "0.75rem",
  color: "#94A3B8",
  flex: 1,
  "@media (max-width: 414px)": {
    fontSize: "0.7rem",
  },
});

const CallInfoWrapper = styled(Box)({
  display: "flex",
  alignItems: "flex-end",
  gap: "3px",
});

const CallTime = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isOwnMessage",
})<{ isOwnMessage?: boolean }>(({ isOwnMessage }) => ({
  fontWeight: isOwnMessage ? 400 : 500,
  fontSize: "0.75rem",
  color: isOwnMessage ? "#64748B" : "#666668",
  justifyContent: "flex-end",
  lineHeight: 0.7,
  "@media (max-width: 414px)": {
    fontSize: "0.7rem",
  },
}));

interface Props {
  id: string;
  date: string;
  time: string;
  title: string;
  subTitle: string;
  senderId: string;
  chatId: string;
  callType: CallTypes;
  isMissedCall: boolean;
  loggedInUserId: string;
}

class CustomCallBubble extends Component<Props> {
  render() {
    const {
      time,
      title,
      loggedInUserId,
      senderId,
      subTitle,
      callType,
      isMissedCall,
    } = this.props;
    const isOwnMessage = loggedInUserId === senderId;

    return (
      <MainWrapper>
        <CallBubble className={isOwnMessage ? "own_message" : ""}>
          <CallContentWrapper>
            <CallIconWrapper isMissedCall={isMissedCall}>
              <img src={CALL_ICONS[callType]} alt="Call" />
            </CallIconWrapper>
            <Box>
              <TitleText>{title}</TitleText>
              <SubTitleText>{subTitle}</SubTitleText>
            </Box>
          </CallContentWrapper>
          <CallInfoWrapper>
            <CallTime isOwnMessage={isOwnMessage}>{time}</CallTime>
          </CallInfoWrapper>
        </CallBubble>
      </MainWrapper>
    );
  }
}

export default CustomCallBubble;
// Customizable Area End
